module.exports = __webpack_public_path__ + "static/media/sliderHome4.eea922e7.jpg";